import React from 'react';
import {Helmet} from 'react-helmet-async';

function SEO({ title, description, name, type }) {

  return (
    <>
      <Helmet>
          { /* Стандартные мета теги */}
          <title>{title}</title>
          <meta name='description' content={description} />
          { /* Метатеги для ВКонтакте*/}
          <meta property="og:type" content={type} />
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          { /* Метатеги для Twitter*/}
          <meta name="twitter:creator" content={name} />
          <meta name="twitter:card" content={type} />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
      </Helmet>
      </>
  );
}


export default SEO;
